/**
* Instagram JS
* -----------------------------------------------------------------------------
*
* All the JS for the Instagram component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'instagram',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.sbi_link' ).addClass( 'w-full h-full grid place-content-center' );
      $( '.sbi_instagram_link' ).css( 'position', 'static', 'important' );
      $( '.sbi_instagram_link' ).append( '<div class="flex flex-col gap-y-4 !text-white mt-3"><p class="hdg-1">Follow Us</p><p class="paragraph-default">@sumalifehouse</p></div>' );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'instagram', COMPONENT );
} )( app );
